import { combineReducers } from 'redux'

import { userReducer as user } from './user'
import { notificationChannelReducer as notificationChannel } from './notification-channel'
import RootState from '@src/redux/types'

const rootReducer = combineReducers<RootState>({ user, notificationChannel })

export default rootReducer
